import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CompanyService } from '../../../../services/company.service';
import { CustomerTypeService } from '../../../../services/customer-type.service';
import { Company } from '../../../../models/company';
import { Customer_Type } from '../../../../models/customer_Type';
import { AuthService } from '../../../../services/auth.service';
import { Audit_Log } from '../../../../models/audit_log';

@Component({
  selector: 'app-company-manage',
  templateUrl: './company-manage.component.html',
  styleUrls: ['./company-manage.component.css']
})
export class CompanyManageComponent implements OnInit {

  company: Company;
  customerTypes: Customer_Type[];
  client;

  constructor(authService: AuthService, private companyService: CompanyService, public router: Router, public route: ActivatedRoute,
    customerTypeService: CustomerTypeService) {

    this.client = authService.currentUser.value;

    customerTypeService.getAll().then((data) => {
      this.customerTypes = data;
    });

  }

  ngOnInit() {
    this.company = new Company();

    this.route.queryParams.subscribe(params => {
      const id = params['company_Id'];
      if (id != undefined) {
        this.companyService.get(id).then((data) => {
          this.company = data;
          this.company.audit_Log = new Audit_Log();
          this.company.is_edit = true;
        });
      }
    });
  }

  submit() {

    this.company.audit_Log.entity = this.company.audit_Log.auditTypes.Companies;
    this.company.audit_Log.entity_Id = this.company.company_Id;

    this.company.audit_Log.user_Id = this.client.userId;
    this.company.audit_Log.description = this.client.firstname + " " + this.client.lastname;

    if (this.company.is_edit) {
      this.company.audit_Log.actionType = this.company.audit_Log.actionTypes.UPDATE;
    }
    else {
      this.company.audit_Log.actionType = this.company.audit_Log.actionTypes.INSERT;
    }

    this.companyService.save(this.company).then((data) => {
      if (data.success) {
        this.router.navigate(['administration/customer_management']);
      }
    });
  }

}
